module.exports = __webpack_public_path__ + "img/phone-in-hand.6625c646.png";